var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.658,
    height: 44,
    viewBox: "0 0 146.658 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_65687",
    "data-name": "Group 65687",
    transform: "translate(-2385.476 -4679.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    d: "M245.033,144.56H117.891c-.337,0-.671.011-1.008.011a14.645,14.645,0,0,0-2.171.2,6.869,6.869,0,0,0-3.82,1.959,6.828,6.828,0,0,0-1.288,1.758,7.027,7.027,0,0,0-.671,2.073,14.37,14.37,0,0,0-.2,2.171c0,.326-.011.659-.011,1v25.659c0,.337.011.671.011,1.008a14.37,14.37,0,0,0,.2,2.171,7.177,7.177,0,0,0,.671,2.073,7.1,7.1,0,0,0,3.047,3.024,7.005,7.005,0,0,0,2.061.693,16.313,16.313,0,0,0,2.171.189c.337,0,.671.011,1.008.011H246.207c.326,0,.671-.011,1-.011a15.99,15.99,0,0,0,2.171-.189,7.225,7.225,0,0,0,2.073-.693,6.851,6.851,0,0,0,1.758-1.277,6.772,6.772,0,0,0,1.959-3.82,14.369,14.369,0,0,0,.2-2.171v-1.008c.011-.39.011-.784.011-1.186V154.917c0-.4,0-.8-.011-1.186v-1a14.369,14.369,0,0,0-.2-2.171,6.852,6.852,0,0,0-1.959-3.831,7.1,7.1,0,0,0-1.758-1.288,7.028,7.028,0,0,0-2.073-.671,14.369,14.369,0,0,0-2.171-.2c-.326,0-.671-.011-1-.011Z",
    transform: "translate(2276.756 4534.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M119.449,189.152c-.337,0-.648,0-.985-.011a12.31,12.31,0,0,1-2.027-.178,6.271,6.271,0,0,1-1.8-.595,5.8,5.8,0,0,1-1.512-1.1,5.88,5.88,0,0,1-1.107-1.523,6.47,6.47,0,0,1-.595-1.8,12.964,12.964,0,0,1-.178-2.027c-.011-.235-.011-1-.011-1V155.269s.011-.75.011-.974a12.74,12.74,0,0,1,.178-2.027,6.589,6.589,0,0,1,.595-1.815,6.068,6.068,0,0,1,1.1-1.512,5.809,5.809,0,0,1,1.523-1.107,6.121,6.121,0,0,1,1.8-.595,12.984,12.984,0,0,1,2.039-.178l.974-.011h128.3l1,.011a12.717,12.717,0,0,1,2.016.178,6.119,6.119,0,0,1,1.815.595,5.654,5.654,0,0,1,1.512,1.107,5.992,5.992,0,0,1,1.118,1.523,5.914,5.914,0,0,1,.572,1.792,13.14,13.14,0,0,1,.189,2.05c.011.3.011.637.011.963v25.647c0,.349,0,.671-.011,1.008a14.064,14.064,0,0,1-.178,2,6.014,6.014,0,0,1-.595,1.815,5.866,5.866,0,0,1-1.1,1.512,6.078,6.078,0,0,1-1.523,1.107,6.308,6.308,0,0,1-1.815.595,12.1,12.1,0,0,1-2.027.178c-.315.011-.648.011-.974.011H119.449Z",
    transform: "translate(2275.197 4533.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_65685",
    "data-name": "Group 65685",
    transform: "translate(101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M154.1,165.86h-12.18c-5.745,0-7.848,2.092-7.848,7.837v12.18c0,5.745,2.1,7.848,7.848,7.848H154.1c5.734,0,7.837-2.1,7.837-7.848V173.7C161.934,167.952,159.842,165.86,154.1,165.86Z",
    transform: "translate(2261.012 4521.669)",
    fill: "#d00c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M151.067,190.307l-.337.75h-.75l1.6-3.638h.648l1.6,3.638h-.773l-.326-.75Zm.265-.659h1.118l-.561-1.3Zm11.869-2.228h.739v3.638H163.2Zm-2.9,2.979h2.027v.659h-2.755v-3.638h2.675v.671H160.3v.739h1.345v.671H160.3Zm-2.1-2.979h.773l-1.266,3.649h-.625l-.83-2.395-.83,2.395h-.606l-1.277-3.649h.8l.807,2.509.819-2.509h.606l.83,2.509Zm-9.345,0h.739v2.061a1.468,1.468,0,0,1-1.58,1.645,1.452,1.452,0,0,1-1.557-1.622v-2.08h.739v2.062c0,.614.292.94.83.94s.83-.326.83-.917Zm-4.165,0h.739v3.649H144.7v-1.489h-1.667v1.489h-.739v-3.649h.739v1.467H144.7Zm8.417-4.635a4.634,4.634,0,0,1-4.635-4.635h.648a3.987,3.987,0,0,0,7.973,0h.648A4.644,4.644,0,0,1,153.113,182.785Z",
    transform: "translate(2255.907 4514.037)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65686",
    "data-name": "Group 65686",
    transform: "translate(2404.789 4684.961)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u0645\\u062A\\u062C\\u0631_\\u0647\\u0648\\u0627\\u0648\\u064A",
    "data-name": "\\u0645\\u062A\\u062C\\u0631 \\u0647\\u0648\\u0627\\u0648\\u064A",
    transform: "translate(83 28)",
    fontSize: 12,
    fontFamily: "IBMPlexSansArabic-SemiBold, IBM Plex Sans Arabic",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -56.268,
    y: 0
  }, "\u0645\u062A\u062C\u0631 \u0647\u0648\u0627\u0648\u064A")), /*#__PURE__*/React.createElement("text", {
    id: "\\u0627\\u062D\\u0635\\u0644_\\u0639\\u0644\\u064A\\u0647",
    "data-name": "\\u0627\\u062D\\u0635\\u0644 \\u0639\\u0644\\u064A\\u0647",
    transform: "translate(83 11)",
    fontSize: 10,
    fontFamily: "IBMPlexSansArabic-Regular, IBM Plex Sans Arabic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -42.37,
    y: 0
  }, "\u0627\u062D\u0635\u0644 \u0639\u0644\u064A\u0647"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.279cc084c090158a82916f0208e19110.svg";
export { ForwardRef as ReactComponent };